import * as React from "react";
import Link from "gatsby-link";
import styled from "styled-components";

// Local
import SideNavigation, {
  SideNavigationTheme
} from "../components/SideNavigation";
import Header, { HeaderTheme } from "../components/Header";
import FirstSection from "../components/HomeSection/FirstSection";
import SecondSection from "../components/HomeSection/SecondSection";
import {
  ScrollContainer,
  ScrollSection,
  ScrollWrapper
} from "../components/ScrollSection";
import { ThemeContextConsumer } from "../context/ThemeContext";
import { ChildOptions } from "../components/ScrollSection/ScrollWrapper";

interface IndexPageProps {
  data: any;
}

interface SectionOptions {
  "data-header-theme": HeaderTheme;
  "data-sideNavigation-theme": SideNavigationTheme;
}

class IndexPage extends React.Component<IndexPageProps, {}> {
  private _items: any[];
  constructor(props: any) {
    super(props);
    this.state = {
      activeContainer: 1
    };
    this._items = [
      {
        single: true,
        text: "discover us",
        transparent: true
      },
      {
        single: false,
        prev: "previous work.",
        next: "next work.",
        transparent: false
      },
      {
        single: false,
        prev: "previous work.",
        next: "next work.",
        transparent: false
      },
      {
        single: false,
        prev: "previous work.",
        next: "next work.",
        transparent: false
      }
    ];
  }

  render() {
    const { _items } = this;

    return (
      <React.Fragment>
        <SideNavigation options={_items[0]} />
        <ThemeContextConsumer>
          {({ change }) => (
            <ScrollWrapper
              beforeChange={(next: ChildOptions<SectionOptions>) => {
                change({
                  "header": next.properties["data-header-theme"],
                  "sideNavigation": next.properties["data-sideNavigation-theme"]
                })
              }}
            >
              <ScrollContainer
                data-sideNavigation-theme={SideNavigationTheme.LIGHT}
                data-header-theme={HeaderTheme.LIGHT}
              >
                <ScrollSection
                  data-sideNavigation-theme={SideNavigationTheme.DARK}
                  data-header-theme={HeaderTheme.DARK}
                >
                  <FirstSection bgImage={this.props.data.firstSectionImage} />
                </ScrollSection>
                <ScrollSection>
                  <FirstSection bgImage={this.props.data.firstSectionImage} />
                </ScrollSection>
                <ScrollSection>
                  <SecondSection />
                </ScrollSection>
              </ScrollContainer>
            </ScrollWrapper>
          )}
        </ThemeContextConsumer>
      </React.Fragment>
    );
  }
}

export const query = graphql`
  query IndexQuery {
    firstSectionImage: imageSharp(id: { regex: "/cover-img/" }) {
      sizes(maxWidth: 1024) {
        ...GatsbyImageSharpSizes_noBase64
      }
    }
  }
`;

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.tsx